import { BorrowerInputVariables } from '@sparrow-card/sparrow-card-constants';
import Link from 'components/Link';

export enum Paragraph {
  Apply = 'We need a bit of information about you. This won’t take long.',
  Review = 'Carefully review the terms of your new account, then you’ll be on your way!',
}

export const APPLY_TITLE = 'Apply now';

export const DEMO_TEXT_MESSAGES_CHECKBOX = 'checkBoxTextMessages';

export const DemoApplyFormRequiredFields: Partial<Record<BorrowerInputVariables, boolean>> = {
  [BorrowerInputVariables.FirstName]: true,
  [BorrowerInputVariables.MiddleInitial]: false,
  [BorrowerInputVariables.LastName]: true,
  [BorrowerInputVariables.Email]: false,
  [BorrowerInputVariables.Phone]: true,
  [BorrowerInputVariables.DateOfBirth]: true,
  [BorrowerInputVariables.SSN]: true,
  [BorrowerInputVariables.TotalMonthlyIncome]: true,
  [BorrowerInputVariables.Street]: true,
  [BorrowerInputVariables.Unit]: false,
  [BorrowerInputVariables.City]: true,
  [BorrowerInputVariables.State]: true,
  [BorrowerInputVariables.Zip]: true,
  [BorrowerInputVariables.CheckBoxTerms]: true,
  [BorrowerInputVariables.CheckBoxElectronicCommunications]: true,
  [BorrowerInputVariables.CheckBoxContracted]: true,
  [BorrowerInputVariables.CheckBoxCreditReport]: true,
};

export const LocationInputsRequired = {
  street: DemoApplyFormRequiredFields[BorrowerInputVariables.Street] ?? true,
  state: DemoApplyFormRequiredFields[BorrowerInputVariables.State] ?? true,
  zip: DemoApplyFormRequiredFields[BorrowerInputVariables.Zip] ?? true,
  unit: DemoApplyFormRequiredFields[BorrowerInputVariables.Unit] ?? false,
  city: DemoApplyFormRequiredFields[BorrowerInputVariables.City] ?? true,
};

const CONSENT_TO_BE_CONTACTED_HREF = 'https://www.sparrowcard.com/legal/consent-to-be-contacted';

export const CHECK_BOX_TERM_LABEL = (
  <>
    By clicking this checkbox, I certify that I’ve read and agree to the above terms of the Sparrow
    account, including the information about eligibility, rates, fees, and other costs. If your
    Sparrow account was opened within the last year and you’ve already paid the first-year annual
    fee, you will not be charged the first-year annual fee again. The monthly annual fee will begin
    one year after the original annual fee’s billing date. If you have not paid your first-year
    annual fee, this fee will be billed to your account upon reopen.
  </>
);

export const CHECK_BOX_COMMUNICATIONS_LABEL = (
  <>
    Paperless Communications and Statements: By clicking this checkbox, I certify that I’ve read and
    agree to the{' '}
    <Link target="_blank" href="https://www.sparrowcard.com/legal/electronic-communication-consent">
      Electronic Communications Agreement
    </Link>
    . By agreeing, I understand that I am consenting to receive electronically (instead of paper)
    all communications about my application, as well as with my account if I am approved. I
    understand that I may change my paperless settings once I set up online access.
  </>
);

export const CHECK_BOX_PHONE_CONTACT_LABEL = (
  <>
    By clicking this checkbox, I certify that I have read the{' '}
    <Link target="_blank" href={CONSENT_TO_BE_CONTACTED_HREF}>
      Consent to be Contacted
    </Link>{' '}
    policy and agree that Sparrow may contact me via automated phone calls, including through the
    use of automatic dialing technology, at the phone number provided, for any lawful purpose
    relating to my account, including information, servicing, or collections purposes.
  </>
);

export const CHECK_BOX_TEXT_MESSAGES_LABEL = (
  <>
    By clicking this checkbox, I certify that I have read the{' '}
    <Link target="_blank" href={CONSENT_TO_BE_CONTACTED_HREF}>
      Consent to be Contacted
    </Link>{' '}
    policy and agree that Sparrow may send me automated text messages at the phone number provided
    for any lawful purpose relating to my account, including information, servicing, or collections
    purposes. I understand that I may reply STOP at any time to stop receiving text messages, or
    HELP for assistance. Message frequency varies. Message and data rates may apply.
  </>
);

export const CHECK_BOX_REPORT_LABEL = (
  <>
    Credit Report Authorization: By clicking this checkbox, I certify that I’ve read and agree to
    the{' '}
    <Link target="_blank" href="https://www.sparrowcard.com/legal/credit-report-authorization">
      Credit Report Authorization Agreement
    </Link>
    , and I authorize Sparrow to obtain consumer credit reports and other information about me on an
    ongoing basis for the administration, servicing, and review of my account.
  </>
);
